import { useCallback, useEffect, useState } from "react";

interface AccessRequest {
  id: string;
  email: string;
  status: string;
  createdAt: string;
}

// Admin-only panel: the pending access-request queue with approve/deny. Renders
// nothing when the queue is empty. Mounted only for admins by App.
export function AdminRequests() {
  const [requests, setRequests] = useState<AccessRequest[]>([]);

  const load = useCallback(async () => {
    try {
      const res = await fetch("/api/access-requests");
      if (res.ok) setRequests((await res.json()) as AccessRequest[]);
    } catch {
      /* transient — reloads on the next action */
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  const act = async (id: string, action: "approve" | "deny") => {
    await fetch(`/api/access-requests/${id}/${action}`, { method: "POST" }).catch(() => {});
    void load();
  };

  if (requests.length === 0) return null;

  return (
    <div className="admin-requests">
      {/* h2: both mounts (sidebar, admin console) sit directly under an h1 */}
      <h2>Pending access ({requests.length})</h2>
      <ul>
        {requests.map((r) => (
          <li key={r.id}>
            <span className="req-email" title={r.email}>
              {r.email}
            </span>
            <span className="req-actions">
              <button onClick={() => void act(r.id, "approve")}>Approve</button>
              <button onClick={() => void act(r.id, "deny")}>Deny</button>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
